import React, { useEffect, useMemo, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportMonitorIpsStock,
  getMonitorFundCodes,
  getMonitorIps,
  getMonitorIpsStock,
  getMonitorItemCategories,
  getMonitorItems,
  getMonitorShipments,
  getMonitorStock,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorDashboardComponent from "components/MonitorDashboard/MonitorDashboardComponent"
import { exportMonitorInventoryReport } from "store/monitor-reports/monitor-report-action"
const MonitorDashboard = props => {
  //meta title
  document.title = "Dashboard"

  const [filters, setFilters] = useState(null)
  const [filtersIP, setFiltersIP] = useState(null)

  // get monitor inventory dashboard data
  const monitorStock = useSelector(state => state.monitorDashboard.monitorStock)

  // get monitor IPs inventory dashboard data
  const monitorIpsStock = useSelector(
    state => state.monitorDashboard.monitorIpsStock
  )

  const user = useSelector(state => state.auth?.user)
  const defaultFilters = useMemo(() => {
    const ids = user?.item_categories
    return ids?.length ? { item_category_ids: ids } : {}
  }, [user?.item_categories])

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = values => {
    setFilters(values)
  }
  // Callback function to toggle the IPs advanced search filter visibility when the button is clicked
  const onIPsAdvanceSearchHandler = values => {
    setFiltersIP(values)
    dispatch(getMonitorIpsStock(values))
  }

  // Trigger export process when Export button is clicked in Provider
  const onProviderStockExport = () => {
    dispatch(exportMonitorInventoryReport(filters))
  }

  // Trigger export process when Export button is clicked in IPs Dashboard
  const onIPStockExport = () => {
    dispatch(exportMonitorIpsStock(filtersIP))
  }

  const dispatch = useDispatch()

  // Fetch new Dashboard data when form submited
  const onSubmit = values => {
    dispatch(getMonitorStock(values))
  }

  // Fetch new Items when Item Category Changed
  const onCategoryChange = category => {
    dispatch(getMonitorItems(category))
  }

  // fetch data based monitor dashboard need
  useEffect(() => {
    dispatch(getMonitorStock(defaultFilters))
    dispatch(getMonitorIpsStock(defaultFilters))
    dispatch(getMonitorIps())
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorFundCodes())
    dispatch(getMonitorShipments())
  }, [dispatch, defaultFilters])

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Dashboard"} />
      {/* Monitor Dashabord Component  */}
      <MonitorDashboardComponent
        provStock={monitorStock?.data?.data?.monitorReports}
        provIpsStock={monitorIpsStock?.data?.data}
        provData={monitorStock?.data?.data}
        onSubmit={onSubmit}
        onCategoryChange={onCategoryChange}
        onAdvancedSearchHandler={onAdvancedSearchHandler}
        onProviderStockExport={onProviderStockExport}
        onIPsAdvanceSearchHandler={onIPsAdvanceSearchHandler}
        onIPStockExport={onIPStockExport}
      />
    </React.Fragment>
  )
}

export default MonitorDashboard
